<!--
  ~ Copyright (C) 2024 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="calendar-integration-prompt">
  <div class="calendar-integration-prompt__content">
    <span class="calendar-integration-prompt__message">{{ data.message }}</span>
    <button mat-button class="calendar-integration-prompt__link" (click)="onGoToSettings()">
      {{ 'translations.calendarIntegration.prompt.goToSettings' | transloco }}
    </button>
  </div>
  <ptl-button
    class="calendar-integration-prompt__close"
    [ariaLabel]="'translations.global.ariaLabels.close' | transloco"
    [icon]="LucideX"
    [type]="'tertiary-neutral'"
    (click)="onDismiss()"
  >
  </ptl-button>
</div>
